export const PERSONAL_CONTEXT_TYPE = 'PERSONAL';
export const ENTERPRISE_CONTEXT_TYPE = 'ENTERPRISE';

export const ContextTypes = [PERSONAL_CONTEXT_TYPE, ENTERPRISE_CONTEXT_TYPE];



// WEBPACK FOOTER //
// ./app/actions/context/ContextTypes.js